<template>
  <div class="scratch-card" v-if="showContent">
    <p class="title" v-if="ticket.contemplated && isScratched">Você foi contemplado!!</p>
    <p class="ticket-number" v-if="ticket.contemplated && isScratched"><b>#{{ ticket.number }}</b></p>

    <scratch-card :key="renderCount" :cardWidth="cardWidth" :cardHeight="cardHeight" :finishPercent="finishPercent"
      :imageUrl="img" :forceReveal="forceReveal" @complete="scratchDone()">
      <div class="ticket-card" :class="{ 'ticket-card-contemplated': ticket.contemplated }">
        <!-- <div class="card-title" v-if="!ticket.contemplated">
          <p>Não foi dessa vez!</p>
        </div> -->
        <img class="try-again" v-if="!ticket.contemplated" src="../assets/images/tente_outra_vez_paizao_premiado.png" alt="não foi dessa vez">
        <!-- <time>{{ ticket.created_at | formatDate }}</time> -->
        <img :src="ticket.product.images[0].url" alt="" v-if="ticket.contemplated && ticket.product.images.length > 0" />
        <!-- <p v-if="ticket.product.extra_price">{{ ticket.product.extra_price }}</p> -->
      </div>
    </scratch-card>
    <p class="product-name" v-if="ticket.contemplated && isScratched">{{ ticket.product.name }}</p>
    <font-awesome-icon icon="far fa-times-circle" class="close-icon" @click="hideScratch" id="close-scratch-btn" />
    <div class="scratch-overlay" v-if="showContent" @click="hideScratch" id="scratch-overlay"></div>
  </div>
</template>

<script>
import ScratchCard from 'vue-scratchcard';
// import BRUSH from '../assets/images/brush-downloaded.png';
// import CampaignMixin from "../mixins/campaign.mixin.js";
// import UserMixin from "../mixins/user.mixin.js";

export default {
  // mixins: [CampaignMixin, UserMixin],
  components: {
    ScratchCard,
  },
  props: {
    ticket: {
      type: Object,
      required: true,
      default: null,
    },
    img: {
      type: String,
      required: false,
      default: null,
    },
    showContent: {
      type: Boolean,
      required: false,
      default: false,
    },
    width: {
      type: String,
      required: false,
      default: '',
    }
  },
  data: function () {
    return {
      title: '',
      isScratched: false,
      renderCount: 0,
      cardWidth: 500,
      cardHeight: 500,
      finishPercent: 50,
      forceReveal: false,
      resizeObserver: null,
      brush: 'data:image/png;base64,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',
      // brushUrl: '../assets/images/brush-downloaded.png',
    };
  },
  mounted: function () {
    if (this.ticket.contemplated) this.title = 'Você foi contemplado!!'
    else this.title = 'Não foi dessa vez!'

    this.updateCardSize()
    this.setupResizeObserver()
  },
  methods: {
    scratchDone() {
      this.$emit('scratched')
      this.isScratched = true
    },
    hideScratch() {
      this.$emit("scratchClosed");
    },
    updateCardSize() {
      const isMobile = window.innerWidth <= 800
      if (isMobile) {
        const availableWidth = window.innerWidth * 0.85
        this.cardWidth = availableWidth
        this.cardHeight = availableWidth
      } else {
        this.cardWidth = 500
        this.cardHeight = 500
      }
      this.renderCount++
    },
    setupResizeObserver() {
      this.resizeObserver = new ResizeObserver(() => {
        this.updateCardSize()
      })
      this.resizeObserver.observe(document.body)
    },
  },
  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  },
};
</script>

<style lang="scss" >
@import "../scss/colors.scss";

.scratch-card {
  z-index: 100;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  .title{
    font-size: 30px;
    color: #fff;
      // color: rgb(120, 50, 5);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.8);
    z-index: 2;
  }

  .ticket-number {
    color: white;
    margin-top: 8px;
    margin-bottom: 15px;
    // color: $text-color;
    font-weight: bold;
    font-size: 20px;
    z-index: 2;
  }

  .product-name {
    font-size: 25px;
    margin-top: 18px;
    text-align: center;
    // color: rgb(120, 50, 5);
    color: white;
    z-index: 2;
  }

  .scratch-overlay {
    position: fixed;
    z-index: 1;
    top: 0;
    left: 0;
    background-color: black;
    opacity: 0.7;
    width: 100vw;
    height: 100vh;
  }

  .scratchcard {
    z-index: 2;
    aspect-ratio: 1;

    .ticket-card {
      background-color: white;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-radius: 20px;

      &-contemplated {

        padding: 20px 15px;
        border: 2px solid #cb9b51;
        background-image: linear-gradient(110deg, #462523 0, #cb9b51 33%, #f6e27a 66%, #f6f2c0 50%, #f6e27a 55%, #cb9b51 78%, #462523 100%);

        // .card-title {
        //   color: rgb(120, 50, 5);
        // }

        // .ticket-number {
        //   color: rgb(120, 50, 5);
        // }


      }

      .try-again {
        border-radius: 20px;
      }

      .card-title {
        font-size: 20px;
      }

      img {
        width: 100%;
        height: 100%;
        aspect-ratio: 1;
        object-fit: contain;
      }

    }
  }

  .scratchcard-overlay {
    object-fit: cover;
    border-radius: 20px;
  }

  .close-icon {
    font-size: 28px;
    margin-top: 12px;
    z-index: 2;
    color: darkgray;
  }

}

@media only screen and (max-width: 800px) {
  .scratch-card {
    .scratchcard {
      width: 85vw;
      max-width: 85vw;
    }
  }
}</style>